<template>
  <div class="flex flex-wrap gap-6 lg:flex-nowrap">
    <template v-for="(banner, index) in banners" :key="index">
      <div
        class="flex flex-1 px-6 md:px-8 rounded-xl relative"
        :class="[
          flexAlignClass(banner),
          paddingClass(banner),
          blockShadow && 'shadow-lg',
        ]"
        :style="{
          color: banner.textColor,
          backgroundColor: banner.bgColor,
          '--text-color': banner.textColor,
          ...useEditorFontFamily(banner.textFontFamily),
        }"
      >
        <BaseImage
          v-if="banner.isBgImage && banner.bgImage"
          :src="banner.bgImage"
          loading="lazy"
          class="absolute inset-0 w-full h-full object-cover rounded-xl"
          alt=""
        />
        <div class="md:w-1/2 flex flex-col gap-4 md:gap-8 relative z-10">
          <div
            class="marked"
            :class="[`text-${banner.textAlign}`]"
            v-html="getMarkedTextWithBlankLinks(banner.text, banner.linkColor)"
          />
          <div
            v-if="banner.buttons?.length"
            class="flex flex-wrap gap-4"
            :class="flexAlignClass(banner)"
          >
            <template v-for="(button, idx) in banner.buttons" :key="idx">
              <EditorButton :button="button" />
            </template>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import type {
  BannerDisplayData,
  BannerPaddingSize,
  BannerTextAlign,
} from './types'
import EditorButton from '~/components/page-editor/EditorButton.vue'

interface PropsInterface {
  banners: BannerDisplayData[]
  blockShadow?: boolean
}

defineProps<PropsInterface>()
const { getMarkedTextWithBlankLinks } = useMarkedText()

const flexAlignClass = (banner: { textAlign?: BannerTextAlign }) => {
  switch (banner.textAlign) {
    case 'left':
      return 'justify-start'
    case 'center':
      return 'justify-center'
    case 'right':
      return 'justify-end'
    default:
      return 'justify-center'
  }
}

const paddingClass = (banner: { paddingSize: BannerPaddingSize }) => {
  switch (banner.paddingSize) {
    case 'xs':
      return 'py-6 md:py-8'
    case 'sm':
      return 'py-14 md:py-20'
    case 'lg':
      return 'py-32 md:py-56'
    default:
      return 'py-20 md:py-40'
  }
}
</script>
